<template>
    <Header></Header>
    <div class="container _activity sub_page">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/activity_left.png" /></i>
                <i class="deco_02 _small blink4"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _small blink_zoom1"><img src="img/b_icon_02.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom4"><img src="img/b_icon_05.png" /></i>
                <i class="deco_05 none_768 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 none_768 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 none_768 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/activity_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>시민참여 활동</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']"><a href="javascript:void(0)">반성매매 시민활동</a></li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">캠페인·이벤트</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']">
                        <a href="javascript:void(0)">참여하고 싶은 반성매매 활동 제안</a>
                    </li>
                    <li v-if="user.isLogin()" @click="changeTab(4)" :class="[state.tab === 4 ? 'active' : '']" class="w_1024_custom_width">
                        <a href="javascript:void(0)">액션 시민 활동</a>
                    </li>
                </ul>
            </div>
        </section>
        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
                <!-- <span class="icon_wrap"><img src="img/part_icon.png" alt="시민참여 활동" /></span>
                <a href="">시민참여 활동</a> -->
                <span class="icon_wrap"><img src="img/part_icon.png" alt="참여하고 싶은 반성매매 활동 제안" /></span>
                <router-link :to="{ path: '/board', query: { type: 3 } }">참여하고 싶은 반성매매 활동 제안</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="글쓰기" /></span>
                <span class="faq_list_title">글쓰기</span>
            </div>
            <div class="sub_page_con_view con_write">
                <ul class="report_con">
                    <li>
                        <label for="title" class="">제목</label>
                        <input id="title" v-model="form_state.title" type="text" placeholder="제목을 입력하세요" />
                    </li>
                    <li class="con_form">
                        <label for="content" class="">내용</label>

                        <textarea class="custom_scroll" id="editor1" name="editor1" v-model="form_state.content"></textarea>
                    </li>
                    <li class="file_wrap">
                        <span class="form_li_tit">첨부</span>
                        <label for="area_file">
                            <input id="area_file" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                            <template v-if="!state.isMobile">
                                <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하여 첨부해주세요</div>
                                <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                                <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                            </template>
                            <template v-else>
                                <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                                <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                            </template>
                        </label>
                        <div class="file_list">
                            <div class="file" v-for="(item, idx) in form_state.file" :key="idx">
                                <!-- <span class="file_name" @click="downloadFile(item.file, item.imgRealName)">{{ item.imgRealName }}</span> -->
                                <img class="file_item" :src="item.file" alt="" @click="showImgModal(item.file)" />
                                <button class="file_del icon_wrap" @click="fileRemove(item.idx)">
                                    <img src="img/close_02.png" alt="" />
                                </button>
                            </div>

                            <div class="file" v-for="(item, index) in state.file" :key="index">
                                <!-- <span class="file_name">{{ item.name }}</span> -->
                                <img class="file_item" :src="CommonUtils.getImgUrl(item)" alt="" @click="showImgModal(CommonUtils.getImgUrl(item))" />
                                <button class="file_del icon_wrap" @click="removeNewFile(index)">
                                    <img src="img/close_02.png" alt="" />
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="btn_wrap _default">
                <button class="common_btn _gray w_180" @click="router.go(-1)">취소</button>
                <button class="common_btn w_180" @click="save">작성완료</button>
            </div>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        userStore,
        onMounted,
        onBeforeMount,
        watch,
        useRoute,
        Header,
        Footer,
        router,
        apiService,
        types,
        ModalDefault,
        ref,
        CommonUtils,
        CkEditorManager,
        onUnmounted,
        getMessageByCode,
        onBeforeUnmount,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                tab: 3 as number,
                idx: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                hasAuth: false,
                file: [] as Array<File>,

                subMenuOpen: false,
                subMenuName: "참여하고 싶은 반성매매 활동 제안" as string,

                isMobile: false,
            });

            const form_state = reactive({
                title: "" as string,
                content: "" as string,
                file: [] as Array<types.ResBoardFileVOForApi>,
            });

            // let editorManager: CkEditorManager | null = null;

            onBeforeMount(() => {
                hasAuth();
            });

            onMounted(async () => {
                const idx = Number(route.params.id);
                if (route.params.id) {
                    if (idx && typeof idx === "number" && !isNaN(idx)) {
                        state.idx = idx;

                        if (user.isLogin()) {
                            // editorManager = new CkEditorManager("editor1", form_state, "suggestion");
                            // await editorManager.initEditor();

                            await getDetail();
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "접근 권한이 없습니다.";
                            state.isShowModal = true;
                        }
                    } else {
                        router.back();
                    }
                } else {
                    // editorManager = new CkEditorManager("editor1", form_state, "suggestion");
                    // editorManager.initEditor();
                }

                state.isMobile = window.innerWidth < 768;
            });

            onBeforeUnmount(() => {
                // editorManager?.destroy();
            });

            watch(
                () => [user.userInfo, user.accessToken],
                () => {
                    hasAuth();
                    if (state.idx > 0) getDetail();
                },
            );

            const hasAuth = () => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("suggest") > -1)))
                )
                    state.hasAuth = true;
            };

            const getDetail = async () => {
                const res = await apiService.boardSuggest.detail(state.idx);

                if (res.returnCode === 0) {
                    if (res.data.meIdx === user.userInfo.idx || state.hasAuth) {
                        form_state.title = res.data.title;
                        form_state.content = CommonUtils.decodeContent(res.data.content);
                        form_state.file = res.data.fileList;

                        // await editorManager?.setDataInfo(form_state.content);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "안내";
                        state.modalContent = "접근 권한이 없습니다.";
                        state.isShowModal = true;
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const changeTab = (tab: number) => {
                global.setBoardTab(tab);
                router.push("/board?type=" + tab);
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민활동";
                        break;
                    case 2:
                        state.subMenuName = "캠페인·이벤트";
                        break;
                    case 3:
                        state.subMenuName = "참여하고 싶은 반성매매 활동 제안";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.boardSuggest.removeFile(state.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = form_state.file.findIndex((item) => item.idx === idxFile);
                    if (index !== -1) {
                        form_state.file.splice(index, 1);
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const closeModal = () => {
                state.isShowModal = false;

                if (state.idx > 0 && state.modalTab === -1) router.replace({ name: "SuggestView", params: { id: state.idx } });
                else if (state.modalTab !== 8 && state.modalTab !== 11) router.replace("/board?type=3");
            };

            const callBackModal = async (param: any) => {
                state.isShowModal = false;
            };

            const save = async () => {
                // form_state.content = (await editorManager?.getData()) + "";
                if (!(form_state.title && form_state.content)) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "제목과 내용을 입력해주세요.";
                    state.isShowModal = true;
                } else {
                    if (!(state.idx > 0)) {
                        const param: types.ReqBoardForSuggest = {
                            title: form_state.title,
                            content: form_state.content,
                            file: state.file,
                        };
                        const res = await apiService.boardSuggest.add(param);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "저장이 완료되었습니다.";
                            state.isShowModal = true;
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = 8;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    } else {
                        const param: types.ReqBoardForSuggestForModify = {
                            title: form_state.title,
                            content: form_state.content,
                            file: state.file,
                        };

                        if (state.file && state.file.length > 0) {
                            param.file = state.file;
                        }

                        const res = await apiService.boardSuggest.modify(state.idx, param);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = 8;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                }
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                if (!target.files) return;

                const files: File[] = Array.from(target.files);

                const isFiles = files.filter((file) => !file.type.startsWith("image/"));

                if (isFiles.length > 0) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "이미지 파일만 업로드할 수 있습니다.";
                    state.isShowModal = true;

                    target.value = "";
                    return;
                }

                state.file = files;
                target.value = "";
            };

            const removeNewFile = (index: number) => {
                state.file.splice(index, 1);
            };

            const showImgModal = (imgUrl: string) => {
                state.modalTab = 11;
                state.modalTitle = "";
                state.modalContent = imgUrl;
                state.isShowModal = true;
            };

            return {
                state,
                user,
                form_state,
                CommonUtils,
                changeTab,
                subMenuTab,
                fileRemove,
                downloadFile,
                closeModal,
                callBackModal,
                showImgModal,
                router,
                save,
                handleFiles,
                removeNewFile,
            };
        },
    };
</script>
<style scoped>
    .btn_wrap._default {
        margin-top: 15px;
    }

    .faq_list_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }

    div.file {
        display: flex;
    }
    .file img.file_item {
        width: 100px;
        height: 100px;
        object-fit: contain;
        cursor: pointer;
    }
</style>
